import React, { useState } from 'react';

const AttendanceModal = ({ 
  show, 
  onClose, 
  formData, 
  onChange, 
  onSave, 
  isEditMode 
}) => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidated(true);
    
    if (!formData.todaystatus || formData.todaystatus === '0') {
      return; // Don't submit if status is not selected
    }

    onSave();
  };

  const isInvalid = validated && (!formData.todaystatus || formData.todaystatus === '0');

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5 className="modal-title">
              {isEditMode ? 'Edit Attendance' : 'Add Attendance'}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label>Employee ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.emp_id || ''}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label>Status</label>
                    <select
                      className={`form-control form-select ${isInvalid ? 'is-invalid' : ''}`}
                      name="todaystatus"
                      value={formData.todaystatus || '0'}
                      onChange={onChange}
                      required
                    >
                      <option value="0">Select Status (Not Mark)</option>
                      <option value="1">Present</option>
                      <option value="2">Absent</option>
                    </select>
                    {isInvalid && (
                      <div className="invalid-feedback">Please select a status</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn mb-1 waves-effect waves-light btn-outline-danger" 
                onClick={onClose}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn mb-1 waves-effect waves-light btn-primary"
              >
                {isEditMode ? 'Update Attendance' : 'Save Attendance'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AttendanceModal;